import { cx } from './cx';
import { filterChipClass } from './FilterChips';

export interface QuickAmountChipsProps {
  amounts?: number[];
  value?: number | null;
  onSelect: (amount: number) => void;
  className?: string;
}

/** Preset amount chips ($10 / $25 / $50 / $100) with the `FilterChips` look; the current amount is selected. */
export default function QuickAmountChips({
  amounts = [10, 25, 50, 100],
  value,
  onSelect,
  className,
}: QuickAmountChipsProps) {
  return (
    <div className={cx('flex flex-wrap gap-2', className)}>
      {amounts.map((amt) => {
        const active = value === amt;
        return (
          <button
            key={amt}
            type="button"
            aria-pressed={active}
            onClick={() => onSelect(amt)}
            className={cx(filterChipClass(active), 'font-money tabular-nums')}
          >
            ${amt}
          </button>
        );
      })}
    </div>
  );
}
